import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

function fmtDate(iso) { try { return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); } catch { return iso; } }

export default function JournalPublic() {
  const { token } = useParams();
  const [entry, setEntry] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/journal/public/${token}`);
        setEntry(data);
      } catch (e) {
        setErr(e.response?.status === 404 ? "This journal entry is private or the link has been revoked." : "Unable to load entry");
      }
    })();
  }, [token]);

  if (err) return <div className="min-h-screen flex items-center justify-center bg-[#F5F1EA] text-[#14181D] font-mono text-sm p-8">{err}</div>;
  if (!entry) return <div className="min-h-screen flex items-center justify-center bg-[#F5F1EA] text-[#14181D] font-mono text-sm">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#F5F1EA]" style={{ color: "#14181D" }}>
      <div className="max-w-2xl mx-auto p-8 lg:p-12">
        <div style={{ fontSize: 10, letterSpacing: "0.28em", textTransform: "uppercase", color: "#8A6B3C", fontWeight: 700 }}>EEPL · Founder Journal</div>
        <h1 style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 40, marginTop: 8, lineHeight: 1.1 }}>{entry.title || "Untitled entry"}</h1>
        <div style={{ fontFamily: "monospace", fontSize: 12, color: "#5E6470", marginTop: 8 }}>{fmtDate(entry.created_at)}</div>
        {entry.tags?.length > 0 && (
          <div style={{ marginTop: 12 }}>
            {entry.tags.map(t => (
              <span key={t} style={{ fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase", fontFamily: "monospace", padding: "2px 8px", border: "1px solid #D8CFBF", color: "#5E6470", marginRight: 6 }}>{t}</span>
            ))}
          </div>
        )}
        <div style={{ marginTop: 32, borderTop: "1px solid #D8CFBF", paddingTop: 32, fontSize: 17, lineHeight: 1.7, whiteSpace: "pre-wrap", color: "#14181D" }}>{entry.body}</div>
        <div style={{ marginTop: 48, fontSize: 11, color: "#8A6B3C", fontFamily: "monospace", letterSpacing: "0.15em", textTransform: "uppercase" }}>End of entry</div>
      </div>
    </div>
  );
}
